import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  invoiceId: yup.number().required(),
  amount: yup.number().required(),
  note: yup.string().nullable(),
});

export function useChargeWithGreenSkyMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    return http.post(HTTP_ENDPOINTS.postChargeInvoiceWithGreenSky(), {
      invoice_id: req.invoiceId,
      requested_payment: req.amount,
      note: req.note,
    });
  }, options);
}
